// 会员管理
import membetManagement from './memberManagement';
// 设置
import ststemSetup from './systemSetup';
// 数据看板
import dataKanban from './dataKanban';
// 营销中心
import marketingMgr from './marketingMgr';
// 潜在用户
import potentialMember from './potentialMember';
// 社交管理
import socialContact from './socialContact';

export const authorityRouter = [
  /// TODO:下面是一个正常页面的路由配置示意，请根据实际项目情况进行配置
  ...membetManagement,
  ...ststemSetup,
  ...dataKanban,
  ...marketingMgr,
  ...potentialMember,
  ...socialContact
];
export default authorityRouter;
